import useAuthStore from "store/authStore";
import { Role } from "utils/server-constants/roles";

const usePortalDashboard = () => {
	const { hasRoles, roles } = useAuthStore();
	const dashboardMap = {
		[Role.SuperAdmin]: "admin-dashboard",
		[Role.Admin]: "admin-dashboard",
		[Role.SeniorPublisher]: "publisher-dashboard",
		[Role.Publisher]: "publisher-dashboard",
		[Role.Institution]: "institution-dashboard",
		[Role.Educator]: "institution-dashboard",
		[Role.Ba]: "ba-dashboard",
	};

	const dashboardUrl = roles ? dashboardMap[roles[0]] : "#";

	/** @var {boolean} canAccessPortal */
	const canAccessPortal = hasRoles([
		Role.SuperAdmin,
		Role.Admin,
		Role.Publisher,
		Role.SeniorPublisher,
		Role.Institution,
		Role.Educator,
		Role.Ba,
	]);

	return {
		dashboardUrl,
		canAccessPortal,
	};
};

export default usePortalDashboard;
